import { core_v1_DataSource } from '@antimatterhq/asl-api-ts-v1';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import { CodeEditor } from '@antimatterhq/ui/components/codeEditor';
import { DatasourceReviewValue } from '../value/DatasourceReviewValue';
import { DatasourceReviewLabel } from '../label/DatasourceReviewLabel';
import { DatasourceUpgradeDiff } from '@/lib/datasource/upgrade/datasourceUpgrade.types';

export type BronzeReviewProps = {
  dataSource: core_v1_DataSource;
  datasourceUpgrade?: DatasourceUpgradeDiff;
};

export const BronzeReview = ({
  dataSource,
  datasourceUpgrade,
}: BronzeReviewProps) => {
  return (
    <div>
      <div>
        <Fieldset.Field>
          <Fieldset.Label>Name:</Fieldset.Label>
          <Fieldset.Value>
            {dataSource?.spec?.bronze?.bronzeTable}
          </Fieldset.Value>
        </Fieldset.Field>
      </div>

      <Spacer size="lg" />

      <div>
        <Fieldset.Field>
          <Fieldset.Label>Auto loader parameters</Fieldset.Label>
        </Fieldset.Field>
        <Fieldset.List>
          <Fieldset.Field>
            <Fieldset.Label>Location of the datasource:</Fieldset.Label>
            <Fieldset.Value data-testid="review-bronze-location">
              {dataSource?.spec?.autoloader?.location}
            </Fieldset.Value>
          </Fieldset.Field>
          <Fieldset.Field>
            <Fieldset.Label>Format of the data:</Fieldset.Label>
            <Fieldset.Value data-testid="review-bronze-format">
              <DatasourceReviewValue
                status={datasourceUpgrade?.spec?.autoloader?.format?.status}
              >
                {dataSource?.spec?.autoloader?.format}
              </DatasourceReviewValue>
            </Fieldset.Value>
          </Fieldset.Field>
        </Fieldset.List>
      </div>

      <Spacer size="lg" />

      <div>
        <Fieldset.Field>
          <Fieldset.Label>Schema file for data</Fieldset.Label>
        </Fieldset.Field>
        <Fieldset.List>
          {dataSource?.spec?.autoloader?.cloudFiles?.schemaHints && (
            <>
              <Fieldset.Field>
                <Fieldset.Label>
                  <DatasourceReviewLabel
                    status={
                      datasourceUpgrade?.spec.autoloader.cloudFiles.schemaHints
                        .status
                    }
                  >
                    Schema hints:
                  </DatasourceReviewLabel>
                </Fieldset.Label>
                <Fieldset.Value></Fieldset.Value>
              </Fieldset.Field>
              <div className="max-h-[300px] overflow-y-auto">
                <CodeEditor
                  code={dataSource.spec.autoloader.cloudFiles.schemaHints}
                  readOnly
                />
              </div>
            </>
          )}
          {dataSource?.spec?.autoloader?.cloudFiles?.schemaHintsFile && (
            <Fieldset.Field>
              <Fieldset.Label>Schema hints file:</Fieldset.Label>
              <Fieldset.Value>
                <DatasourceReviewValue
                  status={
                    datasourceUpgrade?.spec?.autoloader?.cloudFiles
                      ?.schemaHintsFile?.status
                  }
                  data-testid="review-schema-file"
                >
                  {dataSource?.spec?.autoloader?.cloudFiles?.schemaHintsFile}
                </DatasourceReviewValue>
              </Fieldset.Value>
            </Fieldset.Field>
          )}
          {dataSource?.spec?.autoloader?.schemaFile && (
            <Fieldset.Field>
              <Fieldset.Label>Schema file:</Fieldset.Label>
              <Fieldset.Value>
                <DatasourceReviewValue
                  status={
                    datasourceUpgrade?.spec?.autoloader?.schemaFile?.status
                  }
                >
                  {dataSource?.spec?.autoloader?.schemaFile}
                </DatasourceReviewValue>
              </Fieldset.Value>
            </Fieldset.Field>
          )}
        </Fieldset.List>
      </div>
    </div>
  );
};
